import { ChangeDetectionStrategy, Component, inject, OnInit, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet } from '@angular/router';
import { CreateQuestionnairePageComponent } from '../features/create-questionnaire-page/create-questionnaire-page.component';
import { HttpClient } from '@angular/common/http';

import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { SendSuccessComponent } from '../features/create-questionnaire-page/component/send-success/send-success.component';
import { GlobalStore } from '../store/global-store';
import { MiniHeaderComponent } from './mini-header/mini-header.component';
import { toSignal } from '@angular/core/rxjs-interop';
@Component({
    selector: 'que-main-layout',
    imports: [CommonModule, RouterOutlet, TranslateDirective, TranslatePipe
    ],
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainLayoutComponent implements OnInit {
  preview = false;
  ngOnInit(): void {
  }
}
